import { IconButton, IconButtonProps } from "@mui/material";
import classNames from "classnames";
import React, { forwardRef } from "react";

import "./CustomIconButton.scss";

interface ICustomButtonProps extends IconButtonProps {
	"data-testid"?: string;
}

const CustomIconButton = forwardRef<HTMLButtonElement, ICustomButtonProps>((props, ref) => {
	return (
		<IconButton
			{...props}
			ref={ref}
			data-testid={props["data-testid"]}
			className={classNames(props.className, "CustomIconButton")}
		/>
	);
});

export default CustomIconButton;
